import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./TopCompletedPage.css"; // ✅ Reuse the same styling
import StarIcon from "../components/StarIcon"; // ✅ Rating star component

const TopWishlistPage = () => {
  const [books, setBooks] = useState([]);
  const [timeframe, setTimeframe] = useState("");
  const [limit] = useState(20);
  const [skip, setSkip] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const fetchTopWishlist = async (reset = false) => {
    try {
      const currentSkip = reset ? 0 : skip;
      const res = await axios.get(
        "https://bookmatchup.onrender.com/api/lists/top-wishlist",
        {
          params: { timeframe, limit, skip: currentSkip },
        }
      );

      const newBooks = res.data;

      if (reset) {
        setBooks(newBooks);
        setSkip(limit);
      } else {
        setBooks((prev) => [...prev, ...newBooks]);
        setSkip((prev) => prev + limit);
      }

      setHasMore(newBooks.length === limit);
    } catch (err) {
      console.error("Error fetching top wishlisted books:", err);
    }
  };

  useEffect(() => {
    fetchTopWishlist(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeframe]);

  const formatTimeframeLabel = (tf) => {
    if (!tf) return "All Time";
    if (tf === "week") return "Last Week";
    if (tf === "month") return "Last Month";
    if (tf === "year") return "Last Year";
    return tf;
  };

  return (
    <div className="top-completed-page">
      <h2>Most Wishlisted Books ({formatTimeframeLabel(timeframe)})</h2>

      <div className="sort-buttons-wrapper">
        {["", "year", "month", "week"].map((tf) => (
          <button
            key={tf}
            className={`sort-button ${timeframe === tf ? "active" : ""}`}
            onClick={() => setTimeframe(tf)}
          >
            {formatTimeframeLabel(tf)}
          </button>
        ))}
      </div>

      <table className="top-table">
        <thead>
          <tr>
            <th>Count</th>
            <th>Cover</th>
            <th>Title</th>
            <th>Author</th>
            <th>Rating</th>
          </tr>
        </thead>
        <tbody>
          {books.map(({ bookDetails, count }) => {
            const avg = bookDetails.ratingStats?.average;
            const total = bookDetails.ratingStats?.count;
            const hasRating = typeof avg === "number" && total > 0;

            return (
              <tr key={bookDetails._id}>
                <td data-label="Count">{count}</td>
                <td data-label="Cover">
                  {bookDetails.cover_url && (
                    <img
                      src={bookDetails.cover_url}
                      alt="Cover"
                      className="book-cover-img"
                    />
                  )}
                </td>
                <td data-label="Title">
                  {bookDetails.itemId ? (
                    <Link
                      to={`/book/${encodeURIComponent(bookDetails.itemId)}`}
                      className="book-title-link"
                    >
                      {bookDetails.title}
                    </Link>
                  ) : (
                    bookDetails.title
                  )}
                </td>
                <td data-label="Author">
                  {bookDetails.author_name?.join(", ") || "Unknown"}
                </td>
                <td data-label="Rating">
                  {hasRating ? (
                    <div className="score-with-star2">
                      <strong>{avg.toFixed(1)}</strong>{" "}
                      <StarIcon filled={true} size={20} />
                    </div>
                  ) : (
                    "N/A"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {hasMore && (
        <div className="load-more-wrapper">
          <button
            onClick={() => fetchTopWishlist()}
            className="load-more-button"
          >
            Show 20 More
          </button>
        </div>
      )}
    </div>
  );
};

export default TopWishlistPage;
